import Swiper from 'swiper';

let newsSlide;
// eslint-disable-next-line no-unused-vars
let newsBooks;
let newsService;
// eslint-disable-next-line no-unused-vars
let newsMain;
// eslint-disable-next-line no-unused-vars
let testimonialService;
// eslint-disable-next-line no-unused-vars
let interactiveService;
// eslint-disable-next-line no-unused-vars
let featuredArticleService;
const breakpoint = window.matchMedia('(max-width: 767px)');

const carouselProperties = {
  release: {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.release__list--buttons .swiper-button-next',
      prevEl: '.release__list--buttons .swiper-button-prev'
    },
    pagination: {
      el: '.release__list--bullets .swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      545: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  },
  newsHomeSlide: {
    watchOverflow: true,
    spaceBetween: 10,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.newsHomeSlide--buttons .swiper-button-next',
      prevEl: '.newsHomeSlide--buttons .swiper-button-prev'
    },
    pagination: {
      el: '.newsSlide--bullets',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      501: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  },
  newsHomeSlide2: {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 10,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.newsHomeSlide--buttons .swiper-button-next',
      prevEl: '.newsHomeSlide--buttons .swiper-button-prev'
    },
    pagination: {
      el: '.newsSlide--bullets2',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      501: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  },
  mainServiceSlide: {
    watchOverflow: true,
    spaceBetween: 20,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--main',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  },
  testimonialSlide: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--testimonial',
      type: 'bullets',
      clickable: true
    }
  },
  interactiveSlide: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--interactive',
      type: 'bullets',
      clickable: true
    }
  },
  serviceSlide: {
    animateOut: 'fadeOut',
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    margin: 0,
    autoHeight: true,
    mouseDrag: true,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--testimonial',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      1: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  },
  testimonial: {
    animateOut: 'fadeOut',
    items: 1,
    loop: true,
    margin: 0,
    autoHeight: true,
    dots: true,
    nav: false,
    mouseDrag: false,
    dotsContainer: '.interactive-testimonial__control'
  },
  propertyGallery: {
    animateOut: 'fadeOutLeft',
    animateIn: 'fadeInRight',
    items: 1,
    loop: true,
    margin: 0,
    dots: true,
    mouseDrag: false,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true,
    dotsContainer: '#main-slider-dots__list'
  },
  propertyMain: {
    loop: true,
    margin: 12,
    dots: true,
    mouseDrag: false,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 3
      },
      768: {
        items: 6
      }
    }
  },
  booksSliders: {
    watchOverflow: true,
    spaceBetween: 20,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination--news-books',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      550: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      767: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
      1023: {
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  }
};

const newsHomeSlide = () => { newsSlide = new Swiper('.swiper-container--news-home-slider', carouselProperties.newsHomeSlide); };
const mainServiceSlide = () => { newsMain = new Swiper('.swiper-container--main', carouselProperties.mainServiceSlide); };
const serviceSlide = () => { newsService = new Swiper('.swiper-container--service', carouselProperties.serviceSlide); };
const testimonialSlide = () => { testimonialService = new Swiper('.swiper-container--testimonial', carouselProperties.testimonialSlide); };
const interactiveSlide = () => { interactiveService = new Swiper('.swiper-container--interactive', carouselProperties.interactiveSlide); };
const booksCarousel = () => { newsBooks = new Swiper('.swiper-container--news-books', carouselProperties.booksSliders); };
const featuredArticleCarousel = () => { featuredArticleService = new Swiper('.swiper-container--feature-articles', carouselProperties.newsHomeSlide2); };

const breakpointChecker = () => {
  mainServiceSlide();
  testimonialSlide();
  newsHomeSlide();
  booksCarousel();
  serviceSlide();
  if (breakpoint.matches === false) {
    $('.swiper-container--news-home-slider .news-item__description').removeClass('news-item__description--mobile');
    $('.swiper-container--news-home-slider .news-item__title').removeClass('news-item__title--mobile');
    $('.swiper-container--feature-articles .news-item__description').removeClass('news-item__description--mobile');
    $('.swiper-container--feature-articles .news-item__title').removeClass('news-item__title--mobile');

    if (newsSlide !== undefined) {
      // console.log(newsMain);
      newsSlide.destroy(true, true);
      $('.newsSlide--bullets').html('');
      $('.swiper-pagination--service').html('');

      $(newsService).each((index) => {
        if (newsService[index] && newsService[index].destroy) {
          newsService[index].destroy(true, true);
        }
      });

      return;
    }
  } if (breakpoint.matches === true) {
    featuredArticleCarousel();
    interactiveSlide();
    $('.swiper-container--news-home-slider .news-item__description').addClass('news-item__description--mobile');
    $('.swiper-container--news-home-slider .news-item__title').addClass('news-item__title--mobile');
    $('.swiper-container--feature-articles .news-item__description').addClass('news-item__description--mobile');
    $('.swiper-container--feature-articles .news-item__title').addClass('news-item__title--mobile');
  }
};

breakpoint.addListener(breakpointChecker);

export default breakpointChecker;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/home/homeCarousel.js